import {
  emailRegExp,
  onlyCharacters,
  onlyCharactersName,
  onlyNumbersReg,
} from "../constants/regexp";

export const checkValueToLength = (
  length,
  value,
  setCorrectFunction,
  setCompleteFunction,
  setErrorMessageFunction
) => {
  if (value.length < length && value.length !== 0) {
    setCorrectFunction(false);
    setCompleteFunction(false);
    setErrorMessageFunction("The value is too short");
    return;
  }
  if (value.length === 0) {
    setCorrectFunction(false);
    setCompleteFunction(false);
    setErrorMessageFunction("The field can not be empty");
    return;
  } else {
    setCorrectFunction(true);
    setCompleteFunction(true);
    setErrorMessageFunction("");
  }
};

export const checkValueToType = (
  type,
  value,
  setCorrectFunction,
  setCompleteFunction,
  setErrorMessageFunction
) => {
  switch (type) {
    case "name":
      const cor = String(value).toLowerCase().match(onlyCharactersName);
      setCorrectFunction(cor);
      setCompleteFunction(cor);
      setErrorMessageFunction(cor ? "" : "Only characters");
      break;
    case "characters":
      const isCorrect = String(value).toLowerCase().match(onlyCharacters);
      setCorrectFunction(isCorrect);
      setCompleteFunction(isCorrect);
      setErrorMessageFunction(isCorrect ? "" : "Only characters");
      break;
    case "number":
      const correct = String(value).toLowerCase().match(onlyNumbersReg);
      setCorrectFunction(correct);
      setCompleteFunction(correct);
      setErrorMessageFunction(correct ? "" : "Only numbers");
      break;
    case "email-change":
      const c = String(value).toLowerCase().match(emailRegExp);
      setCompleteFunction(c);
      break;
    case "email":
      const correctEmail = String(value).toLowerCase().match(emailRegExp);
      setCorrectFunction(correctEmail);
      setCompleteFunction(correctEmail);
      setErrorMessageFunction(correctEmail ? "" : "Your email is invalid");
      break;
  }
};
